import React from 'react'

import Translator from 'bazinga-translator'

import { HeaderWrapper } from '../../../../components/GamesCategoryGrid/styled/HeaderWrapper'
import { Label } from '../../../../components/GamesCategoryGrid/styled/Label'

export function Header() {
  return (
    <HeaderWrapper>
      <Label> {Translator.trans('your_games', {}, 'games')} </Label>
    </HeaderWrapper>
  )
}
